import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { loginAdmin, verifyAdmin } from "@/lib/api";

const TOKEN_KEY = "vini_admin_token";
const USERNAME_KEY = "vini_admin_username";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [username, setUsername] = useState(() => localStorage.getItem(USERNAME_KEY));
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    async function check() {
      const existing = localStorage.getItem(TOKEN_KEY);
      if (!existing) {
        setChecking(false);
        return;
      }
      try {
        await verifyAdmin();
      } catch (e) {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USERNAME_KEY);
        setToken(null);
        setUsername(null);
      } finally {
        setChecking(false);
      }
    }
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = useCallback(async (user, pass) => {
    const data = await loginAdmin(user, pass);
    localStorage.setItem(TOKEN_KEY, data.access_token);
    localStorage.setItem(USERNAME_KEY, data.username);
    setToken(data.access_token);
    setUsername(data.username);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USERNAME_KEY);
    setToken(null);
    setUsername(null);
  }, []);

  return (
    <AdminAuthContext.Provider
      value={{ token, username, isAuthenticated: Boolean(token), checking, login, logout }}
    >
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
};
